import { useMediaQuery as useMediaQueryOriginal } from '@material-ui/core';
export * from '@material-ui/core';
export * from '@material-ui/lab';
export * from '@material-ui/pickers';
export { default as Seo } from './Seo';
export * from './WalletConnect'; // redefine useMediaQuery with noSsr = true by defeault; to prevent useMediaQuery
// from returning a default initial "false" after getting its value:

export var useMediaQuery = function useMediaQuery(queryInput, options) {
  if (options === void 0) {
    options = {
      noSsr: true
    };
  }

  return useMediaQueryOriginal(queryInput, options);
};